// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".related-post-item{cursor:pointer}.related-post-item__picture{height:6rem;width:100%;overflow:hidden;--tw-bg-opacity:1;background-color:rgb(242 242 242 / var(--tw-bg-opacity))}.related-post-item__title{font-family:VNPolarisWeb, Arial Narrow, sans-serif;font-weight:700}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
